import { Yield } from '../../abacus/interfaces/yield.interface'

export const stakeholderGroupYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
